import {projectCode} from "./constants";

const CryptoJS = require("crypto-js");

export const status = "Live";
export const serverLink =
    status === "Dev"
        ?
         "http://localhost:4480/"
        : "https://api.hensarduniversity.edu.ng:4480/"

export const projectURL = "https://hensarduniversity.edu.ng/";
export const projectPhone = " +234-8036424139, +234-8098909053, +234-8180599505";
export const projectEmail = "info@hensarduniversity.edu.ng";
export const serverStatus = status;
export const payStackLive = "pk_live_9f616541a4cf1f71f3d8e2cd236a427a47fab9d9";
export const payStackTest = "pk_live_9f616541a4cf1f71f3d8e2cd236a427a47fab9d9";
// export const payStackTest = "pk_test_900f6286d49dd3d323d4b8e4530501fd060356d6";

export function encryptData(string, val = false) {
    let secret_key= val === false ? projectCode + "_ENCRYPT" : projectCode;
    let secret_iv = val === false ? projectCode + "_ENCRYPT" : projectCode;
    // hash
    let kee = CryptoJS.SHA256(secret_key);
    let ivv = CryptoJS.SHA256(secret_iv).toString().substr(0, 16);

    kee = CryptoJS.enc.Utf8.parse(kee.toString().substr(0, 32));
    ivv = CryptoJS.enc.Utf8.parse(ivv);

    let decrypted = CryptoJS.AES.encrypt(string, kee, { iv: ivv });

    let result = decrypted.toString();
    return btoa(result);
}

export function decryptData(string, val = false) {
    let secret_key = val === false ? projectCode + "_ENCRYPT" : projectCode;
    let secret_iv= val === false ? projectCode + "_ENCRYPT" : projectCode;
    // hash
    let kee = CryptoJS.SHA256(secret_key);
    let ivv = CryptoJS.SHA256(secret_iv).toString().substr(0, 16);

    kee = CryptoJS.enc.Utf8.parse(kee.toString().substr(0, 32));
    ivv = CryptoJS.enc.Utf8.parse(ivv);

    var decrypted = CryptoJS.AES.decrypt(atob(string), kee, { iv: ivv });

    var result = decrypted.toString(CryptoJS.enc.Utf8);
    return result;
}